var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saveBottom"},[_c('div',{staticClass:"record"},[_vm._v(_vm._s(_vm.record))])])
}
var staticRenderFns = []

export { render, staticRenderFns }